import { Component, HostListener } from '@angular/core';
/***** Rxjs *****/
import { Observable } from 'rxjs';
/***** Services *****/
import { GlobalService, Loading } from './services/global.service';

// import { setTheme } from 'ngx-bootstrap/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  /***** Loading *****/
  isLoading$: Observable<Loading>;

  /*** 當使用者與網頁有一次互動後，使用者刷新網頁時，會顯示詢問視窗 ***/
  // @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
  //   console.log("Processing beforeunload...");
  //   // Do more processing...
  //   event.returnValue = false;
  // }

  constructor(
    /***** Services *****/
    private global: GlobalService,
  ) {
    // setTheme('bs4');
    this.isLoading$ = this.global.getLoadingMode();
  }


}
